export type ProjectLoadingState = 'idle' | 'initial' | 'grid';

export function getProjectLoadingState({
  isLoading,
  hasLoadedInitialData,
}: {
  isLoading: boolean;
  hasLoadedInitialData: boolean;
}): ProjectLoadingState {
  if (!isLoading) {
    return 'idle';
  }

  return hasLoadedInitialData ? 'grid' : 'initial';
}
